import { render } from "./Main.vue?vue&type=template&id=35f20f18"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=35f20f18&lang=scss"
script.render = render

export default script